<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        <v-flex>
          <v-layout>
            <v-flex xs6>
              <!-- <div class="subtitle-2 mb-1">Select Region</div> -->
              <v-layout>
                <v-flex class="ml-1" xs6>
                  <v-select
                    outlined
                    dense
                    hide-details
                    return-object
                    :items="regions"
                    v-model="selectedRegion"
                    item-text="name"
                    placeholder="Select Region"
                    @change="selectRegion"
                  >
                  </v-select>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex text-right>
              <v-btn @click="selectRegion" depressed color="primary">
                Refresh
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-title>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="yellow darken-2"
      ></v-progress-linear>
    </v-card>
    <v-layout
      v-if="Object.keys(this.selectedRegion).length === 0"
      justify-center
      align-center
    >
      <div class="title mt-10 grey--text">
        Select a region to see the Chat feed.
      </div>
    </v-layout>
    <template v-for="(item, i) in chats">
      <feed-list-item
        @delete-item="openDeleteDialog"
        @comment-item="toggleCommentDialog"
        :data="item"
        :key="`feed-${i}`"
      />
    </template>
    <v-dialog v-model="dialogComment" width="500">
      <v-card>
        <v-card-title>
          Comments
          <v-spacer />
          <v-btn icon @click="toggleCommentDialog">
            <v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <v-progress-linear
          v-if="isLoadingComments"
          indeterminate
          color="yellow darken-2"
        />
        <v-list>
          <v-list-item v-for="(comment, i) in comments" :key="`comment-${i}`">
            <v-list-item-avatar>
              <v-avatar
                v-if="itemToComment.createdBy === comment.createdBy"
                dark
                color="blue"
              >
                OP
              </v-avatar>
              <v-avatar v-else>
                <v-img :src="avatar(comment)" />
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-flex>
                <div>
                  {{ comment.content }}
                </div>

                <div v-if="comment.adminUser" class="caption grey--text">
                  <v-layout justify-space-between>
                    <div>
                      <div>
                        {{ comment.adminUser.email }}
                      </div>

                      <div>{{ iMoment(comment.createdAt) }}</div>
                    </div>

                    <v-chip
                      label
                      color="yellow"
                      light
                      x-small
                      class="font-weight-bold"
                      >ADMIN</v-chip
                    >
                  </v-layout>
                </div>
                <div v-else class="caption grey--text">
                  <div>
                    {{ comment.createdBy }}
                  </div>
                  <div>
                    {{ iMoment(comment.createdAt) }}
                  </div>
                </div>
              </v-flex>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-layout class="ma-4">
          <v-textarea
            placeholder="Add a comment..."
            outlined
            rows="3"
            v-model="commentText"
          />
        </v-layout>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            class="text-none subtitle-2"
            @click="toggleCommentDialog"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-none subtitle-2"
            outlined
            @click="addComment"
            >Add Comment</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" width="300">
      <v-card>
        <v-card-title>Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            class="text-none subtitle-2"
            @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-none subtitle-2"
            text
            @click="deleteItemConfirm"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import firebase from 'firebase';
import moment from 'moment';
import FeedListItem from '../components/FeedListItem.vue';
export default {
  components: { FeedListItem },
  data() {
    return {
      isLoading: false,
      isLoadingComments: false,
      selectedRegion: {},
      page: 0,
      dialogDelete: false,
      dialogComment: false,
      itemToDelete: {},
      itemToComment: {},
      commentText: '',
      longitude: 0,
      latitude: 0,
      collection: 'pipeline',
    };
  },
  computed: {
    ...mapState('$_auth', ['authUser', 'users']),
    ...mapState('$_feeds', ['chats', 'comments']),
    ...mapState('$_home', ['regions']),
  },
  created() {
    if (this.regions.length === 0) {
      this.getRegions({ collection: 'regions', mutation: 'updateRegions' });
    }
  },
  mounted() {
    this.scroll();
  },

  methods: {
    ...mapActions({
      getFeedByRegion: '$_feeds/getFeedByRegion',
      getComments: '$_feeds/getComments',
      postComment: '$_feeds/postComment',
      getRegions: '$_home/getContent',
      updateChat: '$_content/updateContent',
      deleteChat: '$_content/deleteContent',
    }),
    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp._seconds * 1000;
        return moment(temp).format('lll');
      } else {
        return 0;
      }
    },
    avatar(comment) {
      const baseUrl = 'https://icotar.com/avatar/';
      let avatarHash = '';
      let avatarUri = '';
      let op = this.itemToComment.createdBy;
      if (comment.createdBy == op) {
        avatarHash = 'Original%20Poster';
        avatarUri = `${baseUrl}${avatarHash}.png?s=600`;
      } else {
        avatarHash = `${this.itemToComment.id}${comment.createdBy}`;
        avatarUri = `${baseUrl}${avatarHash}.png?s=600`;
      }
      return avatarUri;
    },
    addComment() {
      let postId = this.itemToComment.id;
      this.isLoadingComments = true;
      this.postComment({
        postId,
        content: this.commentText,
      }).then(() => {
        this.getComments({ postId }).then(() => {
          this.isLoadingComments = false;
          this.commentText = '';
        });
      });
    },
    toggleCommentDialog(item) {
      this.dialogComment = !this.dialogComment;
      if (this.dialogComment) {
        this.isLoadingComments = true;
        this.getComments({ postId: item.id }).then(() => {
          this.isLoadingComments = false;
        });
        this.itemToComment = item;
      } else {
        this.commentText = '';
      }
    },
    selectCustomRegion() {
      var customRegion = {
        longitude: this.longitude,
        latitude: this.latitude,
      };
      this.isLoading = true;
      this.getFeedByRegion({
        mutation: 'updateChats',
        region: customRegion,
      }).then(() => {
        this.isLoading = false;
      });
    },
    openDeleteDialog(item) {
      this.itemToDelete = item;
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      var item = {
        store: {
          collection: 'posts',
          docId: this.itemToDelete.id,
        },
        state: 'deleted',
        deletedItem: this.itemToDelete,
      };
      console.log('DeleteItem', item);
      this.deleteChat({
        details: item,
        collection: this.collection,
        type: 'Conversation',
      }).then(() => {
        this.dialogDelete = false;
        if (this.selectedRegion) {
          this.selectRegion();
        }
      });
    },
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          Math.max(
            window.pageYOffset,
            document.documentElement.scrollTop,
            document.body.scrollTop,
          ) +
            window.innerHeight ===
          document.documentElement.offsetHeight;

        if (bottomOfWindow) {
          this.page++;
          this.isLoading = true;
          this.getFeedByRegion({
            mutation: 'updateChats',
            region: this.selectedRegion,
            page: this.page,
          }).then(() => {
            this.isLoading = false;
          });
        }
      };
    },

    selectRegion() {
      if (this.selectedRegion) {
        if (this.selectedRegion.name === 'All') {
          this.isLoading = true;
          this.getFeedByRegion({
            mutation: 'updateChats',
            region: this.selectedRegion,
          }).then(() => {
            this.isLoading = false;
          });
        } else {
          this.isLoading = true;
          this.getFeedByRegion({
            mutation: 'updateChats',
            region: this.selectedRegion,
            didSwitchRegion: true,
          }).then(() => {
            var vm = this;
            setTimeout(() => {
              vm.isLoading = false;
            }, 3000);
          });
        }
      }
    },
  },
};
</script>

<style></style>
